import { useEffect } from 'react';

const SITE_NAME = 'WorkingClock';

/**
 * Sets `document.title` and the `<meta name="description">` tag per route.
 * No new dependency (react-helmet et al.) for this — this is a client-only
 * SPA (full SSG is a PRD "consideration", not a hard requirement here), so a
 * plain effect covers the brief's per-page title/description ask.
 */
export function usePageMeta(title: string, description: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}
